import React, { useEffect, useMemo, useState, useContext } from 'react';
import { Context } from '../../../context/UserContext';

import { useNavigateParams } from '../../../hooks/useNavigateParams';
import { MaterialReactTable } from 'material-react-table';

import moment from 'moment';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import CustomDialog from '../../layout/CustomDialog';

import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import { Print, Edit } from '@mui/icons-material';
import tratar from '../../../utils/retornaTratamentoURL';
import CrudsAPI from '../../../api/CRUDs';
import * as PlantaoAPI from '../../../api/plantao';

/* util */
import { obterPermissoesUsuario, printPdf } from '../../../utils/funcoes';
import { relatorios } from '../../../api/relatorios';

import { useMRTState } from '../../../hooks/useMRTState';
import { podeImprimir, podeIncluir, podeEditar, podeCancelar } from '../../../hooks/usePermisionMRT';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';

const Index = () => {
    //helper
    const formatHora = (value) => {
        if (!value) return '';
        return moment(value, ['HH:mm:ss', 'HH:mm']).format('HH:mm');
    };
    const simNao = (value) => (value ? 'Sim' : 'Não');

    const [dados, setDados] = useState([]);
    const [token] = useState(localStorage.getItem('token')) || '';
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const pathname = '/Equipes/CreateOrEdit';
    const ul = urlParams.get('ul') || 2;
    const li = urlParams.get('li') || 40;
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || 'Cadastrar';

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    const { parametro } = useContext(Context);

    /* Obtem a paginação padrão */
    useEffect(() => {
        if (parametro && parametro.paginacao) {
            setPagination({
                pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
                pageSize: JSON.parse(localStorage.pagination).pageSize || parametro.paginacao,
            });
        }
    }, [parametro]);

    //obtem o array de empresas vinculadas ou coloca a empresaId no array
    const { empresaId, empresaIds } = getEmpresaScope();

    const [optionsTipo, setOptionsTipo] = useState([]);

    //dialog customizado
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const mrt = useMRTState({
        storageKey: 'equipe.index',
        initialState: {
            columnFilterFns: {},
            columnFilters: [],
            globalFilter: '',
            sorting: [],
            pagination: {
                pageIndex: 0,
                pageSize: parametro?.paginacao || 10,
            },
        },
    });

    const {
        columnFilterFns,
        setColumnFiltersMode,
        columnFilters,
        setColumnFilters,
        globalFilter,
        setGlobalFilter,
        sorting,
        setSorting,
        pagination,
        setPagination,
        isLoading,
        setIsLoading,
        isError,
        setIsError,
        isRefetching,
        setIsRefetching,
        rowCount,
        setRowCount,
    } = mrt;

    //consultas
    const fetchData = async () => {
        if (!dados.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }

        try {
            const { data } = await CrudsAPI.equipe.listar(
                pagination.pageIndex * pagination.pageSize,
                pagination.pageSize,
                JSON.stringify(columnFilters ?? []),
                JSON.stringify(columnFilterFns ?? []),
                globalFilter ?? '',
                JSON.stringify(sorting ?? [])
            );

            setDados(data.data);
            setRowCount(data.meta.totalRowCount);
        } catch (error) {
            setIsError(true);
            console.error(error);
            return;
        }
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };

    const consultaTipo = async () => {
        const result = await PlantaoAPI.obterPlantaoTipos(empresaIds);
        const mappedResult = result.map((item) => ({
            label: item.descricao,
            value: item.descricao,
        }));

        setOptionsTipo(mappedResult);
    };
    //funções do dialog
    const handleOpenDialog = (row) => {
        setOpenDialog(true);
        consultaTipo(empresaIds);
        setSelectedRow(row);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDialog = async () => {
        // Verifique se há uma linha selecionada
        let msgType = 'success';
        if (selectedRow) {
            // Lógica de confirmação
            try {
                const { data } = await CrudsAPI.equipe.deletar(selectedRow);
                setFlashMessage(data.message, msgType);

                // Após a exclusão, chame a função fetchData() novamente para atualizar as unidades
                fetchData();
            } catch (error) {
                msgType = 'error';
                console.error(error);
                setFlashMessage(error.response.data.message, msgType);
            }
        }
        setOpenDialog(false);
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        //funcao para setar localStorage
        localStorage.setItem(
            'pagination',
            JSON.stringify({
                pageIndex: pagination.pageIndex,
                pageSize: pagination.pageSize,
            })
        );
        localStorage.setItem('columnFilterFns', JSON.stringify(columnFilterFns));
        localStorage.setItem('columnFilters', JSON.stringify(columnFilters));
        localStorage.setItem('globalFilter', JSON.stringify(globalFilter));
        localStorage.setItem('sorting', JSON.stringify(sorting));

        //permissões do usuario
        obterPermissoesUsuario(localStorage.getItem('pessoaId'), localStorage.getItem('empresaId'), ul, li);

        consultaTipo();
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, columnFilterFns, columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting, ul, li]);

    const columns = useMemo(
        () => [
            {
                id: 'equipe',
                header: 'Equipes para plantões',
                columns: [
                    {
                        accessorKey: 'Empresa.nomeFantasia',
                        header: 'Empresa',
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {
                                console.info('Célula clicada:', cell.getValue(), row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'descricao',
                        header: 'Descrição',
                    },
                    {
                        accessorKey: 'plantaoTipo.descricao',
                        header: 'Tipo',
                        filterFn: 'equals',
                        columnFilterModeOptions: ['fuzzy', 'equals', 'notEquals'],
                        filterVariant: optionsTipo.length ? 'select' : 'text',
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            ...optionsTipo
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map((option) => ({
                                    label: option.label,
                                    value: option.value,
                                })),
                        ],
                    },
                    {
                        accessorKey: 'inicio',
                        header: 'Início',

                        accessorFn: (row) => moment(row.inicio, 'HH:mm').toDate(),

                        filterVariant: 'time',
                        sortingFn: 'time',

                        muiTableBodyCellProps: {
                            align: 'center',
                        },

                        Cell: ({ row }) => {
                            return <span>{row.original.inicio ? moment(row.original.inicio, 'HH:mm').format('HH:mm') : ''}</span>;
                        },
                    },
                    {
                        accessorKey: 'termino',
                        header: 'Término',

                        accessorFn: (row) => moment(row.termino, 'HH:mm').toDate(),

                        filterVariant: 'time',
                        sortingFn: 'time',

                        muiTableBodyCellProps: {
                            align: 'center',
                        },

                        Cell: ({ row }) => {
                            return (
                                <span>{row.original.termino ? moment(row.original.termino, 'HH:mm').format('HH:mm') : ''}</span>
                            );
                        },
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.ativo;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [optionsTipo] //getCommonEditTextFieldProps
    );

    /* modo tema */
    const theme = tableThemeCustom();

    return (
        <div>
            <div>
                {openDialog && (
                    <CustomDialog
                        title="Delete Equipe!"
                        content="Você tem certeza?"
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                    />
                )}
            </div>
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: {
                                align: 'center',
                            },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true, //turn on some features that are usually off
                            enableResizing: true,
                            muiTableHeadCellProps: {
                                sx: {
                                    fontSize: '1.2rem',
                                },
                            },
                        },
                        'mrt-row-select': {
                            enableColumnActions: true,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    //enableColumnResizing
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row, table }) => {
                        const handleImprimir = async (obj) => {
                            //preciso decidir li=3 pessoa, li= 63 funcionario li=64 usuario
                            const caminho = 'equipeComIntegrantes';
                            const url = 'equipeComIntegrantes';

                            //com isso diminuo a pesquisa na listagem melhorando a performance do sistema
                            const response = await relatorios(caminho, url, obj);

                            printPdf(response.data);
                        };

                        return (
                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                <Tooltip arrow placement="top" title="Editar">
                                    <span>
                                        {' '}
                                        <IconButton
                                            onClick={() => {
                                                params.set('uuid', row.id);
                                                params.set('btnText', 'Atualizar');
                                                navigate(pathname, params);
                                            }}
                                            disabled={JSON.parse(localStorage.getItem('editar')) === false}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow placement="right" title="Imprimir">
                                    <span>
                                        <IconButton
                                            onClick={() => handleImprimir(row.original)}
                                            disabled={localStorage.getItem('imprimir') === 'true' ? false : true}
                                        >
                                            <Print />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Box>
                        );
                    }}
                    renderTopToolbarCustomActions={() => (
                        <div
                            style={{
                                display: 'flex',
                                gap: '8px',
                            }}
                        >
                            <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                <div>
                                    {' '}
                                    <Button
                                        color="secondary"
                                        onClick={() => {
                                            params.delete('uuid');
                                            params.set('btnText', 'Cadastrar');
                                            navigate(pathname, params);
                                        }}
                                        variant="contained"
                                        disabled={JSON.parse(localStorage.getItem('incluir')) === false}
                                    >
                                        Novo
                                    </Button>
                                </div>
                            </Tooltip>
                        </div>
                    )}
                    renderDetailPanel={({ row }) => {
                        const integrantes = row.original?.EquipeIntegrantes || row.original?.equipeIntegrantes || [];

                        return (
                            <Box sx={{ p: 2 }}>
                                <Typography fontWeight={700} fontSize={16} mb={1}>
                                    Integrantes da equipe
                                </Typography>

                                {!integrantes.length ? (
                                    <Typography color="text.secondary">Nenhum integrante vinculado a esta equipe.</Typography>
                                ) : (
                                    <Box
                                        component="table"
                                        sx={{
                                            width: '100%',
                                            borderCollapse: 'collapse',
                                            '& th, & td': {
                                                borderBottom: '1px solid #ddd',
                                                padding: '6px 8px',
                                                fontSize: '0.875rem',
                                            },
                                            '& th': {
                                                textAlign: 'left',
                                                fontWeight: 700,
                                            },
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th>Colaborador</th>
                                                <th>Cargo</th>
                                                <th>Nível</th>
                                                <th>Horário</th>
                                                <th>Diferenciado</th>
                                                <th>Custo Fixo</th>
                                                <th>Outro Dia</th>
                                                <th>Ativo</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {integrantes.map((item) => {
                                                const inicio = item.horarioDiferenciado ? item.inicio : row.original.inicio;
                                                const termino = item.horarioDiferenciado ? item.termino : row.original.termino;

                                                return (
                                                    <tr key={item.uuid || item.id}>
                                                        <td>{item.Pessoa?.descricao || ''}</td>
                                                        <td>{item.rhCargo?.descricao || ''}</td>
                                                        <td>{item.rhNivel?.descricao || ''}</td>
                                                        <td>
                                                            {formatHora(inicio)} às {formatHora(termino)}
                                                        </td>
                                                        <td>{simNao(item.horarioDiferenciado)}</td>
                                                        <td>{simNao(item.custoFixo)}</td>
                                                        <td>{simNao(item.outroDia)}</td>
                                                        <td>{simNao(item.ativo)}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Box>
                                )}
                            </Box>
                        );
                    }}
                    columns={columns}
                    data={dados}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                        isError
                            ? {
                                  color: 'error',
                                  children: 'Error loading data',
                              }
                            : undefined
                    }
                    onColumnFiltersChange={setColumnFilters}
                    onColumnFilterFnsChange={setColumnFiltersMode}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={rowCount}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                        //columnPinning: { left: ["mrt-row-select"] },
                    }}
                    state={{
                        columnFilterFns,
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                    }}
                    //positionToolbarDropZone={"top"}
                    positionExpandColumn={'first'}
                    positionActionsColumn={'first'}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};
export default Index;
